module.exports = __webpack_public_path__ + "static/media/planeta5.4d40288e.png";